import { _ep0, _mw0, command } from "../commandBuilder";
import { DeleteUser$ } from "../schemas/schemas_0";
export class DeleteUserCommand extends command(_ep0, _mw0, "DeleteUser", DeleteUser$) {
}
